export default __webpack_public_path__ + "static/media/convert-transfer.f661fbab.png";